import Vue from 'vue'
import Vuex from 'vuex'
import db from '@/firebase'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    posts: [],
    user: {},
    myfavs: [],
    status: false,
    rankings: []
  },
  mutations: {
    create(state, post) {
      db.collection('items').add({
        user_id: state.user.uid,
        title: post.title,
        type: post.type,
        recommend: post.recommend,
        comment: post.comment,
        createdAt: post.createdAt
      })
      .then(() => {
        router.push('/list')
      })
      .catch(err => {
        console.log(err)
      })
    },
    edit(state, edit_post) {
      if(state.user.uid === edit_post.user_id) {
        db.collection('items').doc(edit_post.id).update({
          title: edit_post.title,
          type: edit_post.type,
          recommend: edit_post.recommend,
          comment: edit_post.comment
        })
        .then(() => {
          router.push('/mylist')
        })
        .catch(err => {
          console.log(err)
        })
      } else {
        alert('作成者のみが編集できます')
      }
    },
    delete(state, id) {
      db.collection('items').doc(id).delete().then(() => {
        state.posts = state.posts.filter(post => post.id !== id)
      })
    },
    get(state, posts) {
      state.posts = posts
    },
    allgood(state, all_good) {
     state.myfavs = all_good
    },
    getmyposts(state, myposts) {
      state.myposts = myposts
    },
    good(state, post) {
      db.collection('goods').add({
        user_id: state.user.uid,
        post_id: post.id,
      })
      .then(() => {
        router.push('/myfavs')
      })
      .catch(err => {
        console.log(err)
      })
    },
    removegood(state, post) {
      db.collection('goods').get().then(snapshot => {
        snapshot.forEach(doc => {
          const select_good = doc.data()
          select_good.id = doc.id
          
          if(select_good.post_id === post.id) {
            db.collection('goods').doc(select_good.id).delete().then(() => {
              state.myfavs = state.myfavs.filter(fav => fav.id !== select_good.id)
              router.push('/myfavs')
            })
            .catch(err => {
              console.log(err)
            })
          }
        })
      })
    },
    ranking(state, ranks) {
      state.rankings = ranks
    },
    onAuthStateChanged(state, user) {
      state.user = user
    },
    onAuthStatusChanged(state, status) {
      state.status = status
    }
  },
  actions: {
    createPost({commit}, post) {
      commit('create', post)
    },
    editPost({commit}, edit_post) {
      commit('edit', edit_post)
    },
    removePost({commit}, id) {
      commit('delete', id)
    },
    getAll({commit, state}) {
      db.collection('items').get().then(snapshot => {
        var tests = []
        snapshot.forEach(doc => {
          const post = doc.data()
          post.id = doc.id
          function checkAlreadyGood(arr, ele) {
            return arr.some(function(value) {
              return ele === value.id
            })
          }
          if(checkAlreadyGood(state.myfavs, post.id)) {
            post.status = true
          } else {
            post.status = false
          }
          tests.push(post)
        });
        commit('get', tests)
      })
    },
    addGood({commit, state}, post) {
      if(state.myfavs.length) {
        state.myfavs.forEach(ele => {
          if(post.id !== ele.id) {
            commit('good', post)
          } else {
            commit('removegood', post)
          }
        })
      } else {
        commit('good', post)
      }
    },
    getGoods({commit, state}) {
      db.collection('goods').get().then(snapshot => {
        var all_good = []
        snapshot.forEach(doc => {
          const good_post = doc.data()
          good_post.id = doc.id
          if(good_post.user_id === state.user.uid){
            db.collection('items').doc(good_post.post_id).get().then(snap => {
              var test = snap.data()
              test.id = snap.id
              all_good.push(test)
            })
          }
        });
        commit('allgood', all_good)
      })
    },
    rank({commit}) {
      db.collection('goods').orderBy('post_id').get().then(res => {
        var g = []
        res.forEach(doc => {
          const rank = doc.data()
          rank.id = doc.id
          db.collection('items').doc(rank.post_id).get().then(res => {
            var ggg = res.data()
            ggg.id = res.id
            g.push(ggg)
          })
        })
        // g.forEach(ele => {
        //   db.collection('items').doc(ele.post_id).get().then(res => {
        //     var ggg = res.data()
        //     ggg.id = res.id
        //     console.log("ress", ggg)
        //   })
        //   // console.log(ele.post_id)
        // })
        commit('ranking', g)
      })
    }
  },
  getters: {
    getAllPost(state) {
      return state.posts
    },
    user(state) {
      return state.user
    },
    isSignedIn(state) {
      return state.status
    }
  },
  modules: {
  }
})
